import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Field, FieldArray, formValueSelector, reduxForm } from 'redux-form'
import FieldArrayComponent from '../../../CommonFields/FieldArrayComponent';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import Loader from '../../../Loader/Loader';
import submit from './submit';
import validate from './validate';
import messages from '../../../../locale/jsonMessages';
import Link from '../../../Link/Link';
import { GoBackArrow } from '../../../Common/Assets/SvgIconComponent/CommonSvgIcon';
import cx from 'classnames';
import bt from '../../../commonStyle.css';

function EditCancellationForm({ handleSubmit }) {
  const { formatMessage } = useIntl();
  const isSelectedLanguage = useSelector(state => formValueSelector('EditCancellationForm')(state, 'dynamicCancellationPolicyContent'))
  const loading = useSelector(state => state?.loader?.updateCancelPolicyLoading)
  return (
    <div >
      <div className={cx(bt.displayFlex, bt.justifyContentSpaceBetween, bt.gap8, bt.space4, bt.flexWrap, bt.alignCenter, bt.spaceBottom4)}>
        <h1 className={cx('siteAdminHeading', bt.spaceBottom0)}>{formatMessage(messages.editCancelPageDetails)}</h1>
        <div >
          <Link to={"/siteadmin/cancellation-policies"} className='goBackLink'>
            <GoBackArrow />
            <FormattedMessage  {...messages.goBack} />
          </Link>
        </div>
      </div>

      <form onSubmit={handleSubmit(submit)}>
        <p className='siteAdminSubHeading'><FormattedMessage {...messages.cancellationTitleOne} /></p>
        <div className='twoColumnGrid'>
          <Field
            name="priorDays"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.priorDays)}
            placeholder={formatMessage(messages.priorDaysPlaceHolder)}
            prefixLabel={formatMessage(messages.howManyDays)}
            toolTipText={formatMessage(messages.toolTipContent1)}
            isAddon={true}
            isRequiredInput
          />
          <Field name="accommodationPriorCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleOne)}
            placeholder={formatMessage(messages.cancellationTitleOnePlaceHolder)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent4)}
            isAddon={true}
            isRequiredInput
          />

          <Field
            name="guestFeePriorCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleTwo)}
            placeholder={formatMessage(messages.cancellationPriorTitleTwo)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent7)}
            isAddon={true}
            isRequiredInput
          />
          <Field
            name="hostFeePriorCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleThree)}
            placeholder={formatMessage(messages.cancellationTitleThreePlaceHolder)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent10)}
            isAddon={true}
          />
        </div>
        <div className={cx(bt.dividerBorder, bt.spaceTop4, bt.spaceBottom4)} />
        <p className='siteAdminSubHeading'><FormattedMessage {...messages.cancellationTitleTwo} /></p>
        <div className='twoColumnGrid'>
          <Field
            name="accommodationBeforeCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleOne)}
            placeholder={formatMessage(messages.cancellationTitleOnePlaceHolder)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent3)}
            isAddon={true}
            isRequiredInput
          />
          <Field
            name="guestFeeBeforeCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleTwo)}
            placeholder={formatMessage(messages.cancellationPriorTitleTwo)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent6)}
            isAddon={true}
            isRequiredInput
          />
          <Field
            name="hostFeeBeforeCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleThree)}
            placeholder={formatMessage(messages.cancellationTitleThreePlaceHolder)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent9)}
            isAddon={true}
            isRequiredInput
          />
        </div>
        <div className={cx(bt.dividerBorder, bt.spaceTop4, bt.spaceBottom4)} />
        <p className='siteAdminSubHeading'><FormattedMessage {...messages.cancellationTitleThree} /></p>
        <div className='twoColumnGrid'>
          <Field
            name="accommodationDuringCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleOne)}
            placeholder={formatMessage(messages.cancellationTitleOnePlaceHolder)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent2)}
            isAddon={true}
            isRequiredInput
          />
          <Field
            name="guestFeeDuringCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleTwo)}
            placeholder={formatMessage(messages.cancellationPriorTitleTwo)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent5)}
            isAddon={true}
            isRequiredInput
          />
          <Field name="hostFeeDuringCheckIn"
            type="text"
            component={CommonFormComponent}
            labelText={formatMessage(messages.cancellationPriorTitleThree)}
            placeholder={formatMessage(messages.cancellationTitleThreePlaceHolder)}
            prefixLabel={'%'}
            toolTipText={formatMessage(messages.toolTipContent8)}
            isAddon={true}
            isRequiredInput
          />
        </div>
        <div className={cx(bt.dividerBorder, bt.spaceTop4, bt.spaceBottom4)} />
        <FieldArray
          name="dynamicCancellationPolicyContent"
          component={FieldArrayComponent}
          selectedLanguage={isSelectedLanguage}
          fieldName="dynamicCancellationPolicyContent"
          isCancellation
          descListClass='twoColumnGrid'
        />

        <div className={cx('singleBtnFlexEnd', bt.spaceTop4)}>
          <Loader
            type={"button"}
            buttonType={"submit"}
            label={formatMessage(messages.save)}
            show={loading}
            className={bt.btnPrimary}
          />
        </div>
      </form>

    </div>
  )
}
export default withStyles(bt)(
  reduxForm({
    form: 'EditCancellationForm',
    validate
  })(EditCancellationForm)
);